import * as net from 'util/Net';

import {DefaultSchemaCollaboratorsConfigurationGraphQL} from '../../graphql-fragments/auth/__generated/DefaultSchemaCollaboratorsConfigurationGraphQL';

export interface DefaultSchemaCollaborator {
  schemaPolicyId: string;
  partyId: string;
  organizationRole?: number;
  teamRole?: number;
}

export interface UpdateDefaultSchemaCollaboratorsConfigurationRequest {
  collaborations: Array<DefaultSchemaCollaborator>;
}

export function updateDefaultSchemaCollaboratorsConfiguration(
  defaultSchemaCollaboratorsConfigurationId: string,
  data: UpdateDefaultSchemaCollaboratorsConfigurationRequest
): Promise<DefaultSchemaCollaboratorsConfigurationGraphQL> {
  return net.patchJSONPromise({
    url: `/1/api/default_schema_collaborators_configuration/${defaultSchemaCollaboratorsConfigurationId}`,
    data,
  });
}
